// Test IDs for Run to Empower Entrepreneurs 5K
export const EVENT5K = {
  // Nav
  navBrand: 'nav-brand',
  navRegister: 'nav-register-btn',
  navAdminLink: 'nav-admin-link',

  // Hero
  heroRegister: 'hero-register-btn',
  heroSponsor: 'hero-sponsor-btn',
  heroVendor: 'hero-vendor-btn',
  heroVolunteer: 'hero-volunteer-btn',
  countdownDays: 'countdown-days',
  countdownHours: 'countdown-hours',
  countdownMinutes: 'countdown-minutes',
  countdownSeconds: 'countdown-seconds',

  // Registration
  registrationDialog: 'registration-dialog',
  regRaceOption5k: 'reg-race-5k',
  regRaceOption1mile: 'reg-race-1mile',
  regFirstName: 'reg-first-name',
  regLastName: 'reg-last-name',
  regEmail: 'reg-email',
  regPhone: 'reg-phone',
  regAge: 'reg-age',
  regTeam: 'reg-team',
  regShirtToggle: 'reg-shirt-toggle',
  regShirtSize: 'reg-shirt-size',
  regYouth: 'reg-youth',
  regSubmit: 'reg-submit-btn',
  regSuccess: 'reg-success-message',
  regTotalDisplay: 'reg-total-display',

  // Vendor
  vendorDialog: 'vendor-dialog',
  vendorApplyBtn: 'vendor-apply-btn',
  vendorBusinessName: 'vendor-business-name',
  vendorContactName: 'vendor-contact-name',
  vendorEmail: 'vendor-email',
  vendorType: 'vendor-type',
  vendorDescription: 'vendor-description',
  vendorSubmit: 'vendor-submit-btn',

  // Sponsor
  sponsorDialog: 'sponsor-dialog',
  sponsorApplyBtn: 'sponsor-apply-btn',
  sponsorCompany: 'sponsor-company',
  sponsorContact: 'sponsor-contact',
  sponsorEmail: 'sponsor-email',
  sponsorLevel: 'sponsor-level',
  sponsorSubmit: 'sponsor-submit-btn',

  // Volunteer
  volunteerDialog: 'volunteer-dialog',
  volunteerBtn: 'volunteer-btn',
  volunteerFirst: 'volunteer-first',
  volunteerLast: 'volunteer-last',
  volunteerEmail: 'volunteer-email',
  volunteerSubmit: 'volunteer-submit-btn',

  // Donation
  donationForm: 'donation-form',
  donationName: 'donation-name',
  donationEmail: 'donation-email',
  donationAmount: 'donation-amount',
  donationSubmit: 'donation-submit-btn',

  // Sections
  sectionHero: 'section-hero',
  sectionOverview: 'section-overview',
  sectionOptions: 'section-options',
  sectionPricing: 'section-pricing',
  sectionVendor: 'section-vendor',
  sectionSponsor: 'section-sponsor',
  sectionGallery: 'section-gallery',
  sectionFamily: 'section-family',
  sectionDetails: 'section-details',
  sectionVolunteer: 'section-volunteer',
  sectionDonation: 'section-donation',
  sectionFaq: 'section-faq',

  // Admin
  adminPassword: 'admin-password-input',
  adminLoginBtn: 'admin-login-btn',
  adminTabRegistrations: 'admin-tab-registrations',
  adminTabVendors: 'admin-tab-vendors',
  adminTabSponsors: 'admin-tab-sponsors',
  adminTabVolunteers: 'admin-tab-volunteers',
  adminTabDonations: 'admin-tab-donations',
  adminExportBtn: 'admin-export-btn',
  adminLogoutBtn: 'admin-logout-btn',
};
